import { IDataSelect } from "@app/interfaces/idata-select"

export const LANGUAGE_NAME: Array<IDataSelect> = [
    { id: 'Aimara', label: 'Aimara' },
    { id: 'Alemán', label: 'Alemán' },
    { id: 'Chino', label: 'Chino' },
    { id: 'Francés', label: 'Francés' },
    { id: 'Griego', label: 'Griego' },
    { id: 'Hebreo', label: 'Hebreo' },
    { id: 'Inglés', label: 'Inglés' },
    { id: 'Italiano', label: 'Italiano' },
    { id: 'Kawesqar', label: 'Kawesqar' },
    { id: 'Latín', label: 'Latín' },
    { id: 'Mapudungún', label: 'Mapudungún' },
    { id: 'Portugés', label: 'Portugés' },
    { id: 'Quechua', label: 'Quechua' },
    { id: 'Rapanui', label: 'Rapanui' },
    { id: 'Ruso', label: 'Ruso' },
    { id: 'Yagán', label: 'Yagán' },
]

export const LANGUAGE_LEVEL: Array<{ id: number, name: string }> = [
    { id: 0, name: "Sin conocimiento" },
    { id: 1, name: "Básico" },
    { id: 2, name: "Intermedio" },
    { id: 3, name: "Avanzado" },
    { id: 4, name: "Nativo" },
]

